import axios from 'axios'
import {ResponseObjectPaginated} from '../../../../../models'
import {GetModuleFilter, ModuleAvailableDto, ModuleModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getModulesService(dto: GetModuleFilter) {
  return axios.post<ResponseObjectPaginated<ModuleModel[]>>(`${BASEURL}/module/getList`, dto)
}

export function getModulesAvailableService(dto: ModuleAvailableDto) {
  return axios.post<ResponseObjectPaginated<ModuleModel[]>>(
    `${BASEURL}/module/getListAvailable`,
    dto,
  )
}

export function getListModulesExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/module/getListExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getTemplateModuleService() {
  return axios.post<any>(
    `${BASEURL}/module/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}
